import { createSlice } from "@reduxjs/toolkit";


// Get user from localStorage
// const general = JSON.parse(localStorage.getItem(process.env.REACT_APP_STORAGE_UI_CONFIG_GENERAL))



const initialState = {
	general : null ,
	 

	 
}

export const uiSlice = createSlice({
	name : "ui",
	initialState,
	reducers : {
        updateGeneralUI : (state , action ) => {
            state.general = action.payload
        },
		/* login : (state , action) => {
			 
			state.user = action.payload
			state.org = action.payload.organizations.find( x => x.is_default === true) ?? action.payload.organizations[0]
			 
		},
        updateOrganization : (state , action ) => {
            state.org = action?.payload
        },
        updateOrganizationPages : ( state , action ) => {
            state.org.statuspages = action?.payload
        }, */
		reset: (state) => {
            state.general = null 
		},
	}
})
export const { reset , updateGeneralUI } = uiSlice.actions
export default uiSlice.reducer
